import {ErrorDialog, ConfirmationDialog} from '@widgets/shift-event-details'
import React from 'react'

import {useInstructionDelete} from '../../hooks/api/useInstructionDelete'
import {useTrackDocumentsAnalytics} from '../../hooks/useTrackDocumentsAnalytics'
import {Instruction} from '../../types/documents.types'

type DocumentsDeleteProps = {
  plantId: string
  country: string
  showDialog: boolean
  instruction: Instruction
  setDialogOpen: (state: boolean) => void
  onSuccess: () => void
  onlyDeleteSeries?: boolean
}

export const DocumentDelete: React.FC<DocumentsDeleteProps> = ({
  plantId,
  country,
  instruction,
  onSuccess,
  showDialog,
  setDialogOpen
}) => {
  const trackAnalyticsEvent = useTrackDocumentsAnalytics({plantId, country})
  const documentDeleteAction = useInstructionDelete({plantId, options: {onSuccess}})

  return (
    <>
      {documentDeleteAction.error ? (
        <ErrorDialog
          httpCode={documentDeleteAction.error.code}
          statusCode={documentDeleteAction.error?.response?.status}
          onClose={() => {
            setDialogOpen(false)
            documentDeleteAction.reset()
          }}
          errorText={documentDeleteAction.error.message}
        />
      ) : (
        showDialog && (
          <ConfirmationDialog
            onDeleteSingle={() => {
              documentDeleteAction.mutate(instruction.id, {
                onSuccess: () => {
                  trackAnalyticsEvent('userDeletesInstruction', {instructionId: instruction.id})
                }
              })
            }}
            onClose={() => setDialogOpen(false)}
            isSingleLoading={documentDeleteAction.isPending}
            title={instruction.title ?? ''}
            isSeriesItem={false}
          />
        )
      )}
    </>
  )
}
